(function() {
  
  /**
   * @ngdoc factory
   * @name RcConsumableUsageList
   * @description Model for the consumable summarization list, wrapped for reseller console to allow Demo mode
   */
  angular
    .module('rcEntities.rcConsumableUsageList', ['binky.core.product.consumable'])
    .factory('RcConsumableUsageList', getUsageListModel);

  /* @ngInject */
  function getUsageListModel($injector, $q, _, ConsumableUsage, ConsumableUsageList, DemoMode) {
    class RcConsumableUsageList extends ConsumableUsageList {
      /**
       * @description Creates a new ConsumableUsageList for use.
       *
       * @param {ConsumableUsageList} usageList the existing ConsumableUsageList that we're copying
       */
      constructor(usageList) {
        super(
          {items: usageList.items, usageTotal: usageList.pagination.itemCount},
          usageList.parentConsumable
        );
      }

      /**
       * @description Method to refresh Consumable Usage list from back-end.
       * @returns {Promise} resolves to ConsumableUsageList on success, else rejects with error
       */
      refresh() {
        if (DemoMode.isEnabled()) {
          // Do not call JIL in demo mode; set up the list via MiniJil.
          const deferred = $q.defer();
          this.$promise = deferred.promise;
          // avoid circular dependency
          const MiniJil = $injector.get('MiniJil');
          MiniJil.getUsageList(
            _.invoke(this, 'parentConsumable.getQueryParams'),
            this.pagination
          ).then(responseData => {
            this.items = _.map(responseData, item => ConsumableUsage.apiResponseTransformer(item));
            deferred.resolve(this);
          });
          return deferred.promise;
        } else {
          return super.refresh();
        }
      }
    }

    return RcConsumableUsageList;
  }
})();
